<div class="user-permissions row" [ngClass]="{ 'is-modal': isModal }">
    <ng-template #permissionControls let-controls="controls">
        <div class="user-permissions-controls list-unstyled">
            <div
                *ngFor="let permissionControl of controls"
                class="user-permissions-control"
                [ngClass]="{
                    'user-permissions-control-read-only': readOnly,
                    'has-claim': hasClaims(permissionControl.claims)
                }"
            >
                <ng-template #permissionControlLabelTemplate>
                    <strong class="user-permissions-control-label">{{
                        permissionControl.label
                    }}</strong>
                    <lsq-icon
                        *ngIf="permissionControl.hasWarningIcon"
                        [type]="icons.AlertWarning"
                        class="alert-warning-icon"
                    >
                    </lsq-icon>
                    <br />
                    <span class="user-permissions-control-description">{{
                        permissionControl.description
                    }}</span>
                </ng-template>

                <lsq-switch
                    [(ngModel)]="permissionControl.isOn"
                    (ngModelChange)="handleClaimsChange()"
                    [disabled]="isSwitchDisabled(permissionControl)"
                    [name]="'permissionControl' + permissionControl.claims[0]"
                    [labelOrientation]="orientation.Right"
                    [labelTemplateRef]="permissionControlLabelTemplate"
                >
                </lsq-switch>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="standardPermissionsUiControls?.length">
        <div
            [ngClass]="{
                'user-permissions-standard': true,
                'col-md-6': adminPermissionsUiControls?.length,
                'col-md-12': !adminPermissionsUiControls?.length
            }"
        >
            <div class="section-header">
                <h2
                    class="section-heading empty-subheading h3"
                    i18n="Non admin level permissions header"
                >
                    {{
                        adminPermissionsUiControls?.length ? 'Standard Permissions' : 'Permissions'
                    }}
                </h2>
            </div>
            <ng-container
                [ngTemplateOutlet]="permissionControls"
                [ngTemplateOutletContext]="{ controls: standardPermissionsUiControls }"
            >
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="adminPermissionsUiControls?.length">
        <div
            [ngClass]="{
                'user-permissions-admin': true,
                'col-md-6': standardPermissionsUiControls?.length,
                'col-md-12': !standardPermissionsUiControls?.length
            }"
        >
            <div class="section-header">
                <h2 class="section-heading h3">
                    <span i18n="Admin level permissions header">Admin-Level Permissions</span>
                    <lsq-icon [type]="icons.AlertWarning" class="alert-warning-icon"></lsq-icon>
                </h2>
                <div class="section-subheading" i18n="Admin level permissions description">
                    These permissions should only be granted to users you trust.
                </div>
            </div>
            <ng-container
                [ngTemplateOutlet]="permissionControls"
                [ngTemplateOutletContext]="{ controls: adminPermissionsUiControls }"
            >
            </ng-container>
        </div>
    </ng-container>
</div>
